import React, { useState, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { Stack, PrimaryButton, TextField, ResponsiveMode } from '@fluentui/react';
import { AppAuthContext } from '../contexts/AppAuthContext';
import { AppThemeContext } from '../contexts/AppThemeContext';
import Loader from './Loader';

const SignIn = () => {

    const { cid, setCid, SignIn } = useContext(AppAuthContext);
    const { theme, responsiveMode } = useContext(AppThemeContext);

    const [loading, setLoading] = useState(false);
    const [companyId, setCompanyId] = useState('');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const myStyles = {
        Container_Stack: {
            root: {
                marginTop: '-10%'
            }
        },
        SignIn_Stack: {
            root: {
                width: (responsiveMode >= ResponsiveMode.large) ? '30%' : '80%',
                padding: '20px',
                // border: '1px solid gray',
                borderRadius: '3px',
                boxShadow: theme.effects.elevation8,
            }
        },
        Login_Button: {
            element: {
                marginTop: '20px',
                width: '100%'
            }
        }
    }
    const myTokens = {
        SignIn_Stack: {
            childrenGap: 10,
        }
    }

    const frmCompany_Submit = async (event) => {
        event.preventDefault();
        setLoading(true);
        setCid(companyId);
        setLoading(false);
    }

    const frmSignIn_Submit = async (event) => {
        event.preventDefault();
        setLoading(true);
        await SignIn(cid, username, password).then(result => {
            if (result === false) {
                setLoading(false);
                // toast.error(msgError);
            }
        }).catch(() => {
            setLoading(false);
            // toast.error(msgError);
        });
    }

    return (
        <Stack horizontalAlign='center' verticalAlign='center' verticalFill styles={myStyles.Container_Stack} >
            <Stack styles={myStyles.SignIn_Stack} tokens={myTokens.SignIn_Stack} >
                {!cid ?
                    <form onSubmit={frmCompany_Submit}>
                        <TextField label="شناسه شرکت" value={companyId} onChange={(ev, val) => setCompanyId(val)} />
                        <PrimaryButton
                            style={myStyles.Login_Button.element}
                            text="اتصال"
                            type="submit"
                        />
                    </form>
                    :
                    <form onSubmit={frmSignIn_Submit}>
                        <TextField label="نام کاربری" value={username} onChange={(ev, val) => setUsername(val)} />
                        <TextField label="رمز عبور" type='password' value={password} onChange={(ev, val) => { setPassword(val) }} canRevealPassword />
                        <PrimaryButton
                            style={myStyles.Login_Button.element}
                            // style={{marginTop:'20px'}}
                            text="ورود"
                            // onClick={frmSignIn_Submit}
                            type="submit"
                        />
                    </form>
                }
            </Stack>
            {loading &&
                <Loader />
            }
        </Stack>
    )
}

export default withRouter(SignIn);